import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=5c44fc3e&scoped=true"
import script from "./Commodity.vue?vue&type=script&lang=js"
export * from "./Commodity.vue?vue&type=script&lang=js"
import style0 from "./Commodity.vue?vue&type=style&index=0&id=5c44fc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c44fc3e",
  null
  
)

export default component.exports